/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { modalContainer } from "../../../theme/commonStyle";
import phoneIconSvg from "../../../assets/icons/generic/IconPhone";
import emailIconSvg from "../../../assets/icons/generic/IconEmail";
import { Theme } from "@mui/material";

const navigationBarStyle = {
  toolBar: (theme: Theme) => ({
    padding: 0,
    ...(theme.palette.mode === "dark"
      ? {
          backgroundColor: "primary.dark",
          color: "primary.contrastText",
        }
      : {}),
  }),
  navigationContainer: {
    height: "4.8rem",
  },
  navigationItem: {
    fontSize: "1rem",
    fontWeight: 300,
    padding: "8px",
  },
  navigationSubList: {
    padding: "0px 15px 0px 40px",
  },
  active: {
    fontWeight: "bold",
  },
  icon: {
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    minWidth: "40px",
    minHeight: "40px",
    padding: 0,
    backgroundSize: { xs: "60%", md: "80%" },
  },
  phoneIcon: (theme: Theme) => ({
    backgroundImage: "url(" + phoneIconSvg + ")",
    [theme.breakpoints.up("md")]: {
      marginLeft: "1rem",
    },
  }),
  mailIcon: (theme: Theme) => ({
    backgroundImage: "url(" + emailIconSvg + ")",
    [theme.breakpoints.up("md")]: {
      marginLeft: "1rem",
    },
  }),
  additionalNavigation: {
    textAlign: "left",
  },
  appResponsive: {
    marginTop: "20px",
  },
  dividerBelow: {
    borderBottom: "1px solid #ddd",
  },
  burgerContainer: {
    textAlign: "right",
  },
  modalContainer,
  drawer: {
    zIndex: 1400,
  },
  navMenuButton: {
    margin: "0 1rem",
  },
  navSkipLink: {
    position: "absolute",
    top: "-40px",
    left: 0,
    zIndex: 1300,
    "&:focus": {
      top: 0,
    },
  },
};

export default navigationBarStyle;
